import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useQuery } from 'react-query'
import { updateModalsKey } from './updateModalsKeys'

export type UpdateModal = {
  id: number
  title: string
  copy: string
  primary_cta_copy: string
  primary_cta_url: string
  secondary_cta_copy?: string
  secondary_cta_url?: string
  hero_image_url: string
}

export const useUpdateModals = () => {
  return useQuery<UpdateModal[]>(
    [updateModalsKey],
    async () => {
      const res = await sendToApi(`/update_modals`)

      if (res.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error()
      }
      return res.data.update_modals
    },
    {
      refetchOnWindowFocus: false,
    },
  )
}
